<template>
  <div>
    <top-nav></top-nav>

    <div id="hero-section">
        <!-- <h2 class="display-7">Hero Section</h2> -->
        <img src='../images/bass1.jpg' class="img-fluid">
    </div>


    <div class="container-fluid">

      <!-- <div class="row row-cols-1 row-cols-md-2">
        <div class="col">
          <div id="about">
            <div class="card bg-dark border-primary mt-3 mb-4">
              <div class="card-header">About Our Club</div>
              <div class="card-body">
                <p class="card-text">
                  Hi, I’m Ralph, the tournament director of the Breaking Water Bass Club.
                  Our club has been fishing together for over 33 years, with tournaments held every Sunday morning.
                  We’d love to have you join us. If you have any questions, please feel free to email me.
                </p>
                <address class="mt-3">
                  Email: <a href="mailto:BreakingWater01@aol.com">Ralph the Tournament Director</a>.<br>
                </address>
              </div>
            </div>
          </div>
        </div>
        <div class="col">
          <div id="news">
            <div class="card bg-dark border-primary mt-3 mb-4">
              <div class="card-header">News & Updates</div>
              <div class="card-body">
                <p><span class="news">2026</span> - Interested in fishing Monday nights? <a href="https://www.facebook.com/profile.php?id=61574937849289" target="_blank">Click Here</a></p>
              </div>
            </div>
          </div>
        </div>
      </div> -->

      <h1 class="mt-5 mb-3">Thank You To Ralph Varney for running the Breaking Water Bass Club for all these years!</h1>
      <h3 class="text-warning mb-5">In 2027 these tournaments will be operated by some new folks. Please keep an eye our for further details.</h3>

      <!-- <div id="details">
        <div class="card bg-dark border-primary mb-4">
          <div class="card-header">Membership & Entry Fees</div>
          <div class="card-body">

            <div class="row">
              <div class="col">
                <ul>
                  <li>$25 yearly membership per person.</li>
                  <li class="text-warning"><strong>No Membership Needed for women & children under 18!</strong></li>
                </ul>
                
              </div>
              <div class="col">
                <ul>
                  <li>$90 Per Boat</li>
                  <li>Includes $10 for Big Bass</li>
                  <li>$10 goes towards the Classic</li>
                  <li>$10 for Second Big Bass (Optional)</li>
                </ul>
              </div>
            </div>
            <a href="/sunday" class="btn btn-primary"><strong>View Rules & Classic Info</strong></a>
          </div>
        </div>
      </div> -->

      <div id="schedule">
        <div class="card bg-dark border-primary mb-4">
          <div class="card-header">2026 Sunday Schedule</div>
          <div class="card-body">
            <table id="resultsTable" class="table table-dark col-lg-6">
              <thead>
                <tr>
                  <th class="h4 table-header" scope="col">Date</th>
                  <th class="h4 table-header" scope="col">Lake</th>
                  <th class="h4 table-header" scope="col">Time</th>
                  <th class="h4 table-header" scope="col">Winner</th>
                </tr>
              </thead>
            </table>
            <h5 class="text-warning">*Belleville Lake - Use Huron River DNR Launch</h5>
            <h5 class="text-warning">TOURNAMENT LAKES ARE OFF LIMITS 24 HOURS BEFORE BLAST OFF TIME.</h5>
          </div>
        </div>
      </div>

      <div id="standings">
        <div class="card bg-dark border-primary mb-4">
          <div class="card-header">Results &  Standings</div>
          <div class="card-body">
            <h4 class="card-title">AOY Top 5</h4>
            <table id="sundayTopFiveTable" class="table table-dark">
              <thead>
                <tr>
                  <th class="h4 table-header" scope="col">Team</th>
                  <th class="h4 table-header" scope="col">Points</th>
                </tr>
              </thead>
            </table>

            <h4 class="card-title">Big Bass 2026</h4>
            <table id="sundayBigBassTable" class="table table-dark">
              <thead>
                <tr>
                  <th class="h4 table-header" scope="col">Team</th>
                  <th class="h4 table-header" scope="col">Weight</th>
                </tr>
              </thead>
            </table>
            <a href="/sunday" class="btn btn-primary"><strong>Full Results & Standings</strong></a>
          </div>
        </div>
      </div>

      

    </div>
  </div>
</template>
<script>
import TopNav from '../components/TopNav.vue';
import { sundaysWithWinners, sundayTopFive, sundayBigBass } from '../data/results.js';
import { buildTable } from '../js/utilities.js';
export default {
  components: {
    TopNav
  },
  mounted() {
    buildTable("resultsTable", sundaysWithWinners);
    buildTable("sundayTopFiveTable", sundayTopFive);
    buildTable("sundayBigBassTable", sundayBigBass);
  }
};
</script>

<style scoped>
  .nav-padding {
    margin-top: 70px; 
  }

 .facebook-button {
      display: inline-block;
      background-color: #1877f2;
      color: white;
      padding: 10px 20px;
      border-radius: 5px;
      text-decoration: none;
      font-family: Arial, sans-serif;
      font-size: 16px;
      font-weight: bold;
      transition: background-color 0.3s;
    }

  .facebook-button:hover {
    background-color: #145dbf;
  }
.news {
  color: rgb(238, 134, 29);
  font-weight: bold;
}
.important {
  color: rgb(235, 44, 27);
  font-weight: bold;
}

.card-header {
  font-size: 20px;
  font-weight: bold;
}

table td {
  font-size: 18px;
}

</style>
